<template>
    <div>
        <a-table :columns="columns" 
                 :data-source="orders" 
                 :pagination="{pageSize: pageSize}"
                 rowKey="orderId"
        >

            <template slot="index" slot-scope="text, record, index">
                <p>{{ index + 1 }}</p>
            </template>

            <template slot="actions" slot-scope="record">
				<a-button-group>
					<a-button shape="circle" icon="eye" size="small" @click="handleBtnView(record)"/>
				</a-button-group>
			</template>
 
        </a-table>
        <order-detail-modal ref="orderModal" :order="currentOrder"/>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import OrderDetailModal from '../../components/modals/OrderDetailModal.vue'
export default {

    components : {
        OrderDetailModal
    },

    data () {
        return {
            pageSize: 5, 
            columns : [
                {
					title: '#',
					dataIndex: 'index',
                    scopedSlots: { customRender: 'index' },
				},
                {
			        title : 'PICKUP NO.',
			        dataIndex: 'pickupNumber',
		        },
                {
					title: 'CUSTOMER',
					dataIndex: 'customerName',
				},
                {
					title: 'STATUS',
					dataIndex: 'status',
				},
                {
					title: 'ORDERED BY',
					dataIndex: 'orderedBy',
				},
                {
			        title : 'ACTIONS',
			        scopedSlots : { customRender: 'actions'},
			        fixed: 'right'
		        }
            ],
            currentOrder : null,
        }
    },
    computed : {
        ...mapGetters({
            //productsByCategory : 'products/productsByCategory'
        }),
        ...mapState({
            orders : state => state.phoneService.orders
        })
    },

    methods : {
        handleBtnView(e) {
			this.$refs['orderModal'].show(e);
		},

        
        
        
    },

    created() {

    }

}
</script>